import FabricByLengthPriceCalculator from "./fabric-by-length/fabric-by-length-price-calculator";

export const initMinQuantity = () => {
  const quantityInput = getQuantityInput();
  const minValue = !!quantityInput && getMinValue(quantityInput);
  if (!minValue) {
    return;
  }
  quantityInput.value = minValue;
  FabricByLengthPriceCalculator.init();
}

const getMinValue = (quantityInput) => {
  const minLength = quantityInput.getAttribute('data-min-number');
  return !!minLength && parseInt(minLength);
}

const getQuantityInput = () => {
  return document.querySelector('.quantity-input');
}


